export default "__VITE_ASSET__nW9YenCb__"